var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccountSettingTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#12A963"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.392 16.5798L19.0718 26.1513C18.7817 26.4504 18.419 26.6 18.0563 26.6C17.6937 26.6 17.2948 26.4504 17.0409 26.1513L12.4352 21.4404C11.8549 20.8421 11.8549 19.9074 12.4352 19.3092C13.0154 18.711 13.9221 18.711 14.5023 19.3092L18.0563 22.9733L26.3249 14.4487C26.9051 13.8504 27.8118 13.8504 28.392 14.4487C28.936 15.0469 28.936 16.019 28.392 16.5798Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountSettingTick);
export default __webpack_public_path__ + "static/media/icon-account-setting-tick.f2ac7edcb1bedf25a7c7dfc5d49c511e.svg";
export { ForwardRef as ReactComponent };